export const init = () => {

  // TRACKER PRODUCT PAGE PANOPLY

  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.product.addPanoply);
  const sep = AnalyticsConstants.separator;
  const fwk = CUBE.Analytics;

  const productName = tc_vars.product_label_displayed;
  const productId = tc_vars.product_id_model;
  const returnLabel = () => productName + sep + fwk.utils.productpage.getSelectedModelId();
  const returnValue = () => { fwk.utils.productpage.getSelectedPrice(); };

  // CloseConversion
  const closeConversion = new AnalyticsClickEvent('closeConversion', tracker.defaultEvent());
  closeConversion.options.action = 'CloseConversionLayer';
  closeConversion.domContainer = '#modal-product-bundles';
  closeConversion.domElement = '.ms__close';
  closeConversion.getLabel = returnLabel;
  closeConversion.getValue = returnValue;
  tracker.addEvent(closeConversion);

  const commonEvent = commonGetters => {
    if (typeof commonGetters === 'undefined') commonGetters = true;
    const comEvent = new AnalyticsClickEvent('event', tracker.defaultEvent());
    comEvent.domContainer = '#modal-express-payment-layout';
    if (commonGetters) {
      comEvent.getLabel = returnLabel;
      comEvent.getValue = returnValue;
    }
    return comEvent;
  };

  // VIRTUAL PAGE - ADD TO PANOPLY
  const addPanoplyVirtualDetail = new AnalyticsEvent('addPanoplyVirtualDetail', tracker.defaultEvent());
  tracker.addEvent(addPanoplyVirtualDetail);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/product/add-panoply-tracker.js